import styled, { keyframes } from 'styled-components';

import { COLOR_TURQUOISE, COLOR_TURQUOISE_040 } from '@common/assets/styles/colors';
const dash = keyframes`
  62% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: 0;
  }
`;

export default styled.div`
  display: inline-flex;

  width: 10px;
  height: 10px;

  svg {
    polyline {
      fill: none;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;

      &.back {
        stroke: ${COLOR_TURQUOISE_040};
      }

      &.front {
        stroke: ${COLOR_TURQUOISE};
        stroke-dasharray: 12, 36;
        stroke-dashoffset: 48;
        animation: ${dash} 1s linear infinite;
      }
    }
  }
`;
